export type CategoryProductFormRow = {
  id: string;
  fieldKey: string;
  fieldFallback: string;
  exampleKey: string;
  exampleFallback: string;
};

/** Paint-shop category tree — main levels only; details live on the product form. */
export const PAINT_CATEGORY_STRUCTURE_MERMAID = `
flowchart TD
    Paint[Paint]

    Paint --> Water[Water-Based Paint]
    Paint --> Oil[Oil-Based Paint]
    Paint --> Primer[Primers]
    Paint --> Accessories[Accessories]

    Water --> WaterInterior[Interior]
    Water --> WaterExterior[Exterior]

    Oil --> OilInterior[Interior]
    Oil --> OilExterior[Exterior]

    WaterInterior --> Wall[Wall Paint]
    WaterInterior --> Ceiling[Ceiling Paint]

    OilInterior --> OilWall[Wall Paint]
`;

/** Example sellable product at the deepest category level. */
export const EXAMPLE_PRODUCT_PATH_MERMAID = `
flowchart TD
    Paint[Paint]
    Paint --> Water[Water-Based Paint]
    Water --> Interior[Interior Paint]
    Interior --> Wall[Wall Paint]
    Wall --> Product[White Matte Wall Paint 5L]
`;

export const CATEGORY_PRODUCT_FORM_ROWS: CategoryProductFormRow[] = [
  {
    id: "category",
    fieldKey: "categories-learn-more-form-category",
    fieldFallback: "Product category",
    exampleKey: "categories-learn-more-form-category-example",
    exampleFallback: "Paint"
  },
  {
    id: "base-type",
    fieldKey: "categories-learn-more-form-base-type",
    fieldFallback: "Paint base type",
    exampleKey: "categories-learn-more-form-base-type-example",
    exampleFallback: "Water-Based / Oil-Based"
  },
  {
    id: "usage",
    fieldKey: "categories-learn-more-form-usage",
    fieldFallback: "Paint usage type",
    exampleKey: "categories-learn-more-form-usage-example",
    exampleFallback: "Interior / Exterior / Wood / Metal / Primer"
  },
  {
    id: "subcategory",
    fieldKey: "categories-learn-more-form-subcategory",
    fieldFallback: "Paint subcategory",
    exampleKey: "categories-learn-more-form-subcategory-example",
    exampleFallback: "Wall Paint / Ceiling Paint / Enamel / Metal Paint"
  },
  {
    id: "finish",
    fieldKey: "categories-learn-more-form-finish",
    fieldFallback: "Finish type",
    exampleKey: "categories-learn-more-form-finish-example",
    exampleFallback: "Matte / Satin / Silk / Gloss / Semi-Gloss"
  },
  {
    id: "color",
    fieldKey: "categories-learn-more-form-color",
    fieldFallback: "Color",
    exampleKey: "categories-learn-more-form-color-example",
    exampleFallback: "White / Black / Blue / Custom"
  },
  {
    id: "packaging",
    fieldKey: "categories-learn-more-form-packaging",
    fieldFallback: "Packaging size",
    exampleKey: "categories-learn-more-form-packaging-example",
    exampleFallback: "1L / 2.5L / 5L / 20L"
  },
  {
    id: "brand",
    fieldKey: "categories-learn-more-form-brand",
    fieldFallback: "Brand",
    exampleKey: "categories-learn-more-form-brand-example",
    exampleFallback: "Optional"
  },
  {
    id: "barcode",
    fieldKey: "categories-learn-more-form-barcode",
    fieldFallback: "Barcode",
    exampleKey: "categories-learn-more-form-barcode-example",
    exampleFallback: "Optional"
  },
  {
    id: "selling-mode",
    fieldKey: "categories-learn-more-form-selling-mode",
    fieldFallback: "Selling mode",
    exampleKey: "categories-learn-more-form-selling-mode-example",
    exampleFallback: "Single Item / Unit Based (Piece) / Measured Quantity"
  },
  {
    id: "base-unit",
    fieldKey: "categories-learn-more-form-base-unit",
    fieldFallback: "Base unit",
    exampleKey: "categories-learn-more-form-base-unit-example",
    exampleFallback: "Liter"
  }
];
